import { apiInstance } from "../config/apiInstance";
import { HealthProviderResponse } from "pages/autorization-payments/types";

interface GetHealthProvidersParams {
  page?: number;
  size?: number;
  hasPayments?: boolean;
  userId?: string;
  paymentLineId?: string;
  stateInvoice?: string;
  attentionPeriodStartedAt?: string;
  attentionPeriodEndedAt?: string;
  documentNumber?: string;
  employerIdNumber?: string;
  filingNumber?: string;
  filingNumberCreatedAtStart?: string;
  filingNumberCreatedAtEnd?: string;
  isCertified?: boolean;
  isContract?: boolean;
  states?: string;
  orderBy?: number;
}

export const getHealthProviders = async (
  params: GetHealthProvidersParams = {}
): Promise<HealthProviderResponse> => {
  const {
    page = 0,
    size = 50,
    hasPayments = true,
    userId = "",
    paymentLineId = "",
    stateInvoice = "",
    attentionPeriodStartedAt = "",
    attentionPeriodEndedAt = "",
    documentNumber = "",
    employerIdNumber = "",
    filingNumber = "",
    filingNumberCreatedAtStart = "",
    filingNumberCreatedAtEnd = "",
    isCertified = false,
    isContract = false,
    states = "",
    orderBy = 1,
  } = params;

  const response = await apiInstance.get(
    "/v1/health-service-providers/findHealthProvider",
    {
      params: {
        page,
        size,
        hasPayments,
        userId,
        paymentLineId,
        stateInvoice,
        attentionPeriodStartedAt,
        attentionPeriodEndedAt,
        documentNumber,
        employerIdNumber,
        filingNumber,
        filingNumberCreatedAtStart,
        filingNumberCreatedAtEnd,
        isCertified,
        isContract,
        states,
        orderBy,
      },
    }
  );

  return response.data;
};
